const designButton = document.querySelector('#customers_canvas_button');
designButton.addEventListener('click', function() {
  let selectedVariantId = getSelectedVariantId();
  let quantity = getQuantity();
  let sku = getSelectedSku();
  
  let paramsString = "?view=customers-canvas-uif&variant=" + selectedVariantId + "&quantity=" + quantity;
  if(sku) {
    paramsString += "&sku=" + sku;
  }
  window.location.search = paramsString;
  
  function getSelectedVariantId() {
    const _getFromForm = () => {
        const formElement = document.querySelector("form[action='/cart/add']");
        const formString = new URLSearchParams(new FormData(formElement)).toString();
        if (formString) {
          const urlSearchParams = new URLSearchParams(formString);
          const objData = Object.fromEntries(urlSearchParams.entries());
          if (objData && objData['id']) {
              return objData['id'];
          } else {
              return null;
          }
        } else {
            return null;
        }
    };
    const _getFromShopifyMeta = () => {
      return window.ShopifyAnalytics?.meta?.selectedVariantId || null;
    }
    const selectedVariantId = _getFromForm() || _getFromShopifyMeta();
    return selectedVariantId == null ? selectedVariantId : Number(selectedVariantId);
  };
  function getQuantity() {
    var qty = document.querySelector("[name='quantity']")?.value;
    if (!qty) {
            qty = 1;
    }
    return qty;
  }

  function getSelectedSku() {
    const sku = window.selectedVariantSku;
    return sku;
  }
});

const qtySelector = document.querySelector("[name='quantity']");
if(!!qtySelector) {
  qtySelector.addEventListener('change', () => {
   if(qtySelector.validity.valid) {
     designButton.disabled  = false;
   } else {
     designButton.disabled  = true;
   }
  });
}